// libs
import * as React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router";
import { UserState } from "redux-oidc";

// components
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import {
  CustomCallback,
  NotFound,
  Spinner,
  UnauthorizedPage,
  mapAuthContextStateToProps,
} from "./components/Common";
import Layout from "./components/Layout";
import { LegacyCreateWizard } from "./components/Legacy/CreateWizard";
import { withNuheat } from "./components/Legacy/hoc/nuheat";
import { LegacyLoadWizard } from "./components/Legacy/LoadWizard";
import ThermostatSimulator from "./components/SimulationTable";
import UWG5NventCreateWizard from "./components/UWG5Nvent/CreateWizard";
import UWG5NventLoadWizard from "./components/UWG5Nvent/LoadWizard";
import { startHubs } from "./index";

// state
import { ApplicationState } from "./store";
import { IAuthProps } from "./store/authTypes";

// style
import "./custom.css";

const NuheatCreateWizard = withNuheat(LegacyCreateWizard);
const NuheatLoadWizard = withNuheat(LegacyLoadWizard);

type AppProps = {
  location: Location;
  oidc?: UserState;
} & IAuthProps;

const App = (props: AppProps) => {
  // Render if loading user or location is unknown
  if (!props.oidc || props.oidc.isLoadingUser || !props.location) {
    return <Spinner description="Loading..." />;
  }

  // Render if NOT admin
  if (props.isAuthenticated && !props.isAdmin) {
    return (
      <UnauthorizedPage description="You have to be an administrator to access this site." />
    );
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    console.debug("User changed: ", props.user);
    startHubs(props.user);
  }, [props.user]);

  // Render if admin or supporter
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Layout>
        <Switch>
          <Route exact path="/" component={ThermostatSimulator} />
          <Route path="/wizard/uwg5nvent" component={UWG5NventCreateWizard} />
          <Route path="/load/uwg5nvent" component={UWG5NventLoadWizard} />
          <Route path="/wizard/nuheat" component={NuheatCreateWizard} />
          <Route path="/load/nuheat" component={NuheatLoadWizard} />

          {/* OIDC */}
          <Route path="/authentication/callback" component={CustomCallback} />

          {/* Default route */}
          <Route path="*" component={NotFound} />
        </Switch>
      </Layout>
    </LocalizationProvider>
  );
};

const mapStateToProps = (
  state: ApplicationState & { router: { location: Location } }
): AppProps => ({
  ...mapAuthContextStateToProps(state),
  location: state.router.location,
  oidc: state.oidc,
});

export default connect(mapStateToProps)(App);
